import React from 'react';
import $ from 'jquery';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Chip from '@material-ui/core/Chip';
import Linkify from 'react-linkify';
import moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  icon: {
    color:'white',
    marginTop:-8,
    marginRight:-8, 
  },
  dialogTitle: {marginRight:14, fontSize: 20}

};
class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    moment.locale('ja', {
      weekdaysShort: ["日","月","火","水","木","金","土"]
    });
  }

  handleMouseEnterOrMouseMove = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(true);
  };
  handleMouseLeave = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(false);
  };
  handleClick = (e) => {
    e.preventDefault();
    this.setState({
      open: true
    });
  };
  handleClose = () => {
    this.setState({open: false});
  };
  nl2br = (text) => {
    var regex = /(\r|\n)/g;
    return text.split(regex).map((line, i) => {
        if (line.match(regex)) {
            return React.createElement('br', {key: i++})
        }
        else {
            return line;
        }
    });
  };
  render = () => {
    const overlay = this.props.overlay;
    if (((!overlay || this.props.program === undefined) && !this.state.open) || this.props.isFullscreen) {
      return (<div/>);
    }
    const { classes } = this.props;
    const program = this.props.program;
    const dateString =
      moment(program.start_time*1000).format('YYYY年MM月DD日(ddd) HH:mm - ')
      + moment(program.end_time*1000).format('HH:mm');
    const genreArea = [];
    const self = this;
    var i = 0;
    if (program.genres) {
      const genreItems = [];
      $(program.genres).each(function() {
        genreItems.push(<Chip key={this.genre} style={{margin:2}} label={this.genre + '/' +this.sub_genre}></Chip>);
      });
      genreArea.push(<div key={i++} style={{color:'white', display: 'flex',flexWrap: 'wrap'}}>{genreItems}</div>);
    }
    const castArea = [];
    if (program.cast) {
      castArea.push(<div key={i++} style={{marginTop:16,fontWeight:'bold'}}>出演者</div>);
      castArea.push(<div key={i++} style={{margin:8}}>{this.nl2br(program.cast)}</div>);
    }
    const itemsArea = [];
    if (program.items) {
      $(program.items).each(function() {
        const item = this;
        itemsArea.push(<div key={i++} style={{marginTop:16,fontWeight:'bold'}}>{item.item_description}</div>);
        $(item.item).each(function() {
          itemsArea.push(<div key={i++} style={{wordWrap:'break-all',margin:8}}><Linkify properties={{target: '_blank'}}>{self.nl2br(this)}</Linkify></div>);
        });
      });
    }
    const dialogStyle = {zIndex: 2147483647};
    // for electron
    // if (navigator.platform.indexOf("Win") === -1) {
    //   dialogStyle['-webkit-app-region'] = 'no-drag';
    //   dialogStyle['-webkit-user-select'] = 'text';
    // }
    let dialog = <div/>;
    if (this.state.open) {
      dialog = (<Dialog
              aria-labelledby="alert-dialog-title"
              open={this.state.open}
              onClose={this.handleClose}
              autoScrollBodyContent={true}
              style={dialogStyle}
            >
              <DialogTitle
                id="alert-dialog-title"
                className={classes.dialogTitle}
                disableTypography={true}
                >{program.name}</DialogTitle>
              <DialogContent>
                {genreArea}
                <div style={{margin:16}}>{dateString}</div>
                <div style={{margin:16}}>{program.text}</div>
                {castArea}
                {itemsArea}
                <IconButton
                  onClick={this.handleClose}
                  style={{top:8, right:8, position:'absolute'}}
                  color='black'
                >
                  <CloseIcon />
                </IconButton>
              </DialogContent>
            </Dialog>);
    }
    return (
      <div
        id="detail"
        onMouseEnter={this.handleMouseEnterOrMouseMove}
        onMouseMove={this.handleMouseEnterOrMouseMove}
        onMouseLeave={this.handleMouseLeave}
        style={{zIndex: 2147483647, position: 'absolute', right: '8px', top: '4px'}}
      >
        <IconButton
          style={styles.icon}
          onClick={this.handleClick}
        >
          <InfoIcon />
        </IconButton>
        {dialog}
      </div>
    );
  };
};
export default withStyles(styles)(Detail);



// WEBPACK FOOTER //
// ./src/components/Detail.js